import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row } from "react-bootstrap";
import { MetricsDateSelector } from '../../../filters/MetricsDateSelector';


export const AdminFeedbackReportFilterBar = (props: {
    filterOptions: any,
    updateFilterOptions: any,
    filterDateOptions: any,
    setFilterDateOptions: any,
    refresh: any,
    isLoading: boolean,
    user: any,
}) => {

    return (
        <>
            <Row className="metrics-sidebar-update">
                <Col md={12} className="d-grid gap-2">
                    <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => {props.refresh()}}
                        disabled={props.isLoading}
                    >
                        {props.isLoading ? <><FontAwesomeIcon icon={faSpinner} spin /> Loading...</> : "Update"}
                    </Button>
                </Col>
            </Row>
            <Row className="mb-4" style={{marginTop: '48px'}}>
                <Col md={12}>
                    <div className="metrics-control-title">Date Range</div>
                    <MetricsDateSelector
                        filterDateOptions={props.filterDateOptions}
                        setFilterDateOptions={props.setFilterDateOptions}
                    />
                </Col>
            </Row>
        </>
    );
};
